import { render, staticRenderFns } from "./editarDatos.vue?vue&type=template&id=52c4114c&scoped=true"
import script from "./editarDatos.vue?vue&type=script&lang=js"
export * from "./editarDatos.vue?vue&type=script&lang=js"
import style0 from "./editarDatos.vue?vue&type=style&index=0&id=52c4114c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4114c",
  null
  
)

export default component.exports